import { type LocalizationInfoResponseDTO, UsersService } from '@klangio/ai2notes-ts-client';

const GDPR_COUNTRY_CODES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CZ',
  'CY',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'EL',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'SK',
  'ES',
  'SE',
  'GB',
  'UK',
  'GR',
  'EU',
];

export const getIpInfoLocalization = (): Promise<LocalizationInfoResponseDTO> => {
  if (
    !window?.sessionStorage.getItem('localization')
    || window?.sessionStorage.getItem('localization') === '{}'
  ) {
    return UsersService.usersGetLocalInfo().then((data) => {
      window.sessionStorage.setItem('localization', JSON.stringify(data));
      return data;
    });
  }
  return Promise.resolve(JSON.parse(window?.sessionStorage.getItem('localization') ?? '{}'));
};

const getRegion = (countryCode: string) => {
  if (!countryCode) return 'eu';
  if (GDPR_COUNTRY_CODES.includes(countryCode)) {
    return 'eu';
  }
  if (countryCode === 'US') {
    return 'us';
  }
  return 'other';
};

const getGDPRRegion = async () => {
  return getIpInfoLocalization()
    .then((data: { country: string }) => {
      return Promise.resolve(getRegion(data?.country));
    })
    .catch((e) => {
      return Promise.resolve(getRegion(e?.country));
    });
};
export default getGDPRRegion;
